import {
    Component,
    Output,
    Input,
    EventEmitter,
    OnChanges,
    AfterViewInit,
    SimpleChange,
    ChangeDetectionStrategy,
    NgZone,
    ElementRef,
    ViewChild,
    Renderer
} from '@angular/core';
import InventoryTreeHolder from '../tree-holder/tree-holder.component';
import { TreeService, TreeNode } from '../../../../../../common/tree';

@Component({
    selector: 'tree-vc',
    template: `
       <div>
        <tree-holder [url]="url" [state]="state" [actionsMap]="menuActionMapping" [linksMap]="menuLinksMapping" autofocus></tree-holder>
      </div>
    `
})
export default class InventoryTreeVC implements AfterViewInit {
    @Input() state: any;
    show: boolean;
    @Output() onShow = new EventEmitter();
    @ViewChild('treeview') treeView: InventoryTreeHolder;
    url: String;
    menuActionMapping: any;
    menuLinksMapping: any;
    constructor(private element: ElementRef,
                private renderer: Renderer, private ngZone: NgZone) {
        this.show = true;
        this.url = '/hybridity/api/vc/query?entityType=vcenter';
    }

    ngOnInit() {
        this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
    }

    ngAfterViewInit() {
        // TODO Find the first root node and preselect
    }

    ngOnChanges(changes: {[propertyName: string]: SimpleChange}) {
        // TODO - Capture state changes and set child components
    }

    toggleState() {
        this.show = !this.show;
        if (this.show) {
            this.onShow.emit(this.show);
            this.renderer.invokeElementMethod(this.element.nativeElement, 'focus', []);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/dataprotection-tree/tree-vc/tree-vc.component.ts